import { authTextFieldSx } from '../auth/authFieldStyles';

export const authControlHeight = 40;

export const darkAuthLinkSx = {
  color: 'rgb(51, 153, 153)',
  '&:visited': { color: 'rgb(51, 153, 153)' },
  textDecoration: 'none',
  '&:hover': { color: 'rgb(51, 153, 153)', textDecoration: 'underline' },
  font: 'inherit',
  fontWeight: 400,
} as const;

export const darkForgotPasswordLinkSx = [
  darkAuthLinkSx,
  {
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
] as const;

export const darkFieldLabelSx = { color: 'text.primary', fontWeight: 400 } as const;

export const darkPasswordIconSx = { color: 'text.secondary' } as const;

export const darkPrimaryButtonSx = {
  backgroundColor: 'primary.main',
  color: 'primary.contrastText',
  height: authControlHeight,
  minHeight: authControlHeight,
  '&:hover': { backgroundColor: 'primary.dark' },
} as const;

export const darkDividerSx = { flex: 1, borderColor: 'divider' } as const;

export const darkDividerTextSx = { color: 'text.secondary', fontWeight: 700 } as const;

export const darkGoogleButtonSx = {
  color: 'text.primary',
  fontWeight: 400,
  height: authControlHeight,
  minHeight: authControlHeight,
  '&:hover': {
    borderColor: 'primary.main',
  },
} as const;

export const darkFooterTextSx = { color: 'text.secondary', textAlign: 'center' } as const;

export const darkAuthTextFieldSx = [
  authTextFieldSx,
  {
    '& .MuiInputLabel-root, & label': { color: 'text.primary' },
    '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
      color: 'text.primary',
    },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'primary.main',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'primary.main',
      borderWidth: '1px',
    },
    '& .MuiInputBase-input::placeholder, & .MuiOutlinedInput-input::placeholder, & input::placeholder':
      {
        color: 'text.secondary',
      },
  },
] as const;
